import initGreenSock from '/lib/greensock'
import initHeadroom from '/lib/headroom'
import initMobileNav from '/lib/mobile-nav'
import initA11yFunctions from '/lib/accessibility'
import initScrolls from '/lib/scrolls'
import initTeamDropdown from '/lib/team-dropdown'
import initTeamAccordion from '/lib/team-accordion'
import initNav from '/lib/nav'
import initNewsletterModal from '/lib/newsletter-modal'

initGreenSock()
initHeadroom()
initMobileNav()
initA11yFunctions()
initScrolls()
initTeamDropdown()
initTeamAccordion()
initNav()
initNewsletterModal()
